export default function getAssessmentCourseTitle(course) {
  return course ? course.title : '';
}
